import { Boundaries } from "@planzone/core";
import { State } from "./types";
import { isInRange } from "./utils";

function handleCreateTaskSuccess(
  state: State,
  { task, project }: Boundaries["createTask"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    calendar: {
      ...req.calendar,
      tasks: isInRange(req.filter, {
        startDate: task.startDate,
        endDate: task.endDate,
      })
        ? [...req.calendar.tasks, { ...task, project }]
        : req.calendar.tasks,
    },
  }));
}

export { handleCreateTaskSuccess };
